import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { Cobertura } from 'src/app/models/complementos-web/complementos-web.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCardContent, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-tooltip-detalle-cobertura',
    templateUrl: './tooltip-detalle-cobertura.component.html',
    styleUrls: ['./tooltip-detalle-cobertura.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCardContent, MatCardActions, MatButton]
})
export class TooltipDetalleCoberturaComponent {

  constructor(
    public dialogRef: MatDialogRef<TooltipDetalleCoberturaComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: { cobertura : Cobertura },
  ) {
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

}
